import _Rate from './rate';
import { withInstall } from '@tdesign/shared-utils';

import './style';

export * from './type';

export const Rate = withInstall(_Rate);

export default Rate;
